import {NeoButton, NeoTextBox} from "@/components/forms";
import {NeoError, NeoSuccess} from "@/components/shared";
import {driversService} from "@/service/drivers.service";
import {useEffect, useState} from "react";
import {AiOutlineLoading} from "react-icons/ai";
import * as yup from "yup";

export const LicenseForm: React.FC<any> = function ({
  documentsEditdata,
  onClose
}) {
  const [loading, setLoading] = useState(false);

  const [filesLicense, setFilesLicense] = useState<File[]>([]);
  const [fileInputsLicense, setFileInputsLicense] = useState([0]);
  const [nameLicense, setNameLicense] = useState<string>("");

  const [filesOthers, setFilesOthers] = useState<File[]>([]);
  const [fileInputsOthers, setFileInputsOthers] = useState([0]);
  const [nameothers, setNameothers] = useState<string>("");
  const [fileNameValiadationLicDoc, setFileNameValidationLicDoc] = useState<
    string | null
  >(null);
  const [fileNameValiadationOthDoc, setFileNameValidationOthDoc] = useState<
    string | null
  >(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [succssMessage, setSuccessMessage] = useState<string | null>(null);
  const validationSchema = yup.object().shape({
    trackerId: yup.number().required("Vehicle is required")
  });
  const [maxDocumentcount, setMaxDocumentcount] = useState(0);
  const [maxOtherDocumentcount, setMaxOtherDocumentcount] = useState(0);
  const allowedCount = 3;

  useEffect(() => {
    const availabledocCount = documentsEditdata?.licenseDocuments?.length;
    setMaxDocumentcount(allowedCount - availabledocCount);
    const availableotherdocCount = documentsEditdata?.otherDocuments?.length;
    setMaxOtherDocumentcount(allowedCount - availableotherdocCount);
  }, [documentsEditdata.licenseDocuments]);
  const onSubmit = async () => {
    const licenceformData = new FormData();
    licenceformData.append("name", nameLicense);
    licenceformData.append("documentType", "1");
    licenceformData.append("driverUserId", documentsEditdata?.driverId);
    licenceformData.append("sourceType", "2");
    setFileNameValidationLicDoc(null);
    setFileNameValidationOthDoc(null);

    const licFiles: any = [];
    if (filesLicense.length > 0) {
      filesLicense.forEach((file, index) => {
        //if (file) licFiles.push(file);
        if (file) licenceformData.append("file", file);
      });
      // if (licFiles.length > 0) {
      //   licenceformData.append("file", licFiles[0]);
      // }
      //license documement logic start
      if (nameLicense) {
        setLoading(true);
        await driversService
          .addDocument(documentsEditdata.userId, licenceformData)
          .then((response: any) => {
            if (response?.status === "success") {
              //push(`/drivers`);
              if (!succssMessage) {
                setSuccessMessage(
                  response?.message || "Files uploaded successfully"
                );
              }
            } else {
              setErrorMessage(
                "Sorry!, We have technical issue please try again later"
              );
            }
          })
          .catch(err => {
            if (err?.errors.length > 0) {
              err?.errors.forEach(
                ({field, message}: {field: any; message: string}) => {
                  //setError(field, {type: "server", message: message});
                }
              );
            }
          })
          .finally(() => {
            setLoading(false);
            const availabledocCount = filesLicense.length;
            const updatedMaxCount =
              maxDocumentcount === 0 ? 0 : maxDocumentcount - availabledocCount;
            setMaxDocumentcount(
              updatedMaxCount === 0 ? 0 : allowedCount - updatedMaxCount
            );
            setFilesLicense([]);
            setFileInputsLicense([]);
            setNameLicense("");
            setTimeout(() => {
              setErrorMessage(null);
              setSuccessMessage(null);
            }, 2000);
          });
      } else {
        setFileNameValidationLicDoc("License document name is required");
        return;
      }
    }

    // other document logic start
    const fileOtherformData = new FormData();
    fileOtherformData.append("name", nameothers);
    fileOtherformData.append("documentType", "0");
    fileOtherformData.append("driverUserId", documentsEditdata?.driverId);
    fileOtherformData.append("sourceType", "2");
    if (filesOthers.length > 0) {
      filesOthers.forEach((file, index) => {
        // if (file) otherDocFiles.push(file);
        if (file) fileOtherformData.append("file", file);
      });
      if (nameothers) {
        setLoading(true);
        await driversService
          .addDocument(documentsEditdata.userId, fileOtherformData)
          .then((response: any) => {
            if (response?.status === "success") {
              //push(`/drivers`);
              if (!succssMessage) {
                setSuccessMessage(
                  response?.message || "Files uploaded successfully"
                );
              }
            } else {
              setErrorMessage(
                "Sorry!, We have technical issue please try again later"
              );
            }
          })
          .catch(err => {
            if (err?.errors.length > 0) {
              err?.errors.forEach(
                ({field, message}: {field: any; message: string}) => {
                  //setError(field, {type: "server", message: message});
                }
              );
            }
          })
          .finally(() => {
            setLoading(false);
            const availabledocCount = filesOthers.length;
            const updatedMaxCount =
              maxOtherDocumentcount === 0
                ? 0
                : maxOtherDocumentcount - availabledocCount;
            setMaxOtherDocumentcount(
              updatedMaxCount === 0 ? 0 : allowedCount - updatedMaxCount
            );
            setFilesOthers([]);
            setFileInputsOthers([]);
            setNameothers("");
            setTimeout(() => {
              setSuccessMessage(null);
              setErrorMessage(null);
            }, 2000);
          });
      } else {
        setFileNameValidationOthDoc("Other document name is required");
        return;
      }
    }
  };
  const handleFileChange = (index: number, file: File | null) => {
    const updatedFiles = [...filesLicense];
    updatedFiles[index] = file!;
    setFilesLicense(updatedFiles);
  };

  const handleOtherFileChange = (index: number, file: File | null) => {
    const updatedFilesOther = [...filesOthers];
    updatedFilesOther[index] = file!;
    setFilesOthers(updatedFilesOther);
  };
  const addFileInput = () => {
    if (fileInputsLicense.length < maxDocumentcount) {
      setFileInputsLicense([...fileInputsLicense, fileInputsLicense.length]);
    }
  };

  const addOtherFileInput = () => {
    if (fileInputsOthers.length < maxOtherDocumentcount) {
      setFileInputsOthers([...fileInputsOthers, fileInputsOthers.length]);
    }
  };

  return (
    <>
      <div className="w-full rounded-lg  border border-gray-200 p-1 shadow-md">
        {/* onSubmit={handleSubmit(onSubmit)} */}
        <div className="rouned-lg mb-2 flex flex-col justify-start border-b-2 border-gray-200 bg-white p-4">
          <h2 className="text-lg font-semibold">Documents Information</h2>
          <p className="text-sm text-gray-500">
            Please fill in the Document information of the driver.
          </p>
        </div>

        <div className="w-full px-5">
          <div className="flex flex-col gap-2 ">
            <div className="grid w-full grid-cols-1 gap-2 border-b p-2 max-sm:grid-cols-1">
              <div className="flex justify-between">
                <label className="block text-sm font-extrabold text-gray-700">
                  License Document
                </label>
                {fileInputsLicense.length < maxDocumentcount ? (
                  <>
                    <button
                      type="button"
                      onClick={addFileInput}
                      className="mt-2 text-sm text-blue-600 underline"
                    >
                      + Add Another
                    </button>
                  </>
                ) : (
                  <>
                    {maxDocumentcount > 0 && (
                      <p className="text-sm font-medium text-red-500">
                        * Maximum 3 files can be uploaded.{" "}
                      </p>
                    )}
                  </>
                )}
              </div>
              {maxDocumentcount > 0 && allowedCount >= maxDocumentcount ? (
                <>
                  <NeoTextBox
                    label="Document Name"
                    id="phone No"
                    defaultValue={nameLicense}
                    value={nameLicense}
                    onChange={(e: any) => setNameLicense(e.target.value)}
                    placeholder="Please enter document name"
                    size="md"
                  />
                  <div className="max-h-40 overflow-y-auto pr-2">
                    {fileInputsLicense.map((_, index) => (
                      <div
                        key={index}
                        className="mt-1 flex items-center space-x-4"
                      >
                        <input
                          type="file"
                          accept="image/*,application/pdf"
                          className="block w-full text-sm text-gray-500 file:mr-4 file:rounded-md file:border-0
            file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700
            hover:file:bg-blue-100"
                          onChange={e =>
                            handleFileChange(index, e.target.files?.[0] ?? null)
                          }
                        />
                        <button
                          onClick={() => {
                            const newInputs = [...fileInputsLicense];
                            const newFiles = [...filesLicense];
                            newInputs.splice(index, 1);
                            newFiles.splice(index, 1);
                            setFileInputsLicense(newInputs);
                            setFilesLicense(newFiles);
                          }}
                          className="text-sm text-red-500 hover:text-red-700"
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div className="flex items-center justify-between rounded-lg border bg-gray-50 p-4">
                    <p className="text-sm font-medium text-red-500">
                      * A maximum of 3 files can be uploaded. To upload more,
                      please delete files from the{" "}
                      <button
                        type="button"
                        className="text-blue-600 underline hover:text-blue-800"
                        onClick={onClose} // Replace with your actual handler
                      >
                        View Page
                      </button>
                      .
                    </p>
                  </div>
                </>
              )}
            </div>
            {fileNameValiadationLicDoc && (
              <p className="text-sm font-medium text-red-500">
                {fileNameValiadationLicDoc}
              </p>
            )}
            <div className="grid w-full grid-cols-1 gap-2 border-b p-2 max-sm:grid-cols-1">
              <div className="flex justify-between">
                <label className="block text-sm font-extrabold   text-gray-700">
                  Other Documents
                </label>
                {fileInputsOthers.length < maxOtherDocumentcount ? (
                  <button
                    type="button"
                    onClick={addOtherFileInput}
                    className="mt-2 text-sm text-blue-600 underline"
                  >
                    + Add Another
                  </button>
                ) : (
                  <>
                    {maxOtherDocumentcount > 0 && (
                      <p className="text-sm font-medium text-red-500">
                        * Maximum 3 files can be uploaded.{" "}
                      </p>
                    )}
                  </>
                )}
              </div>
              {maxOtherDocumentcount > 0 &&
              allowedCount >= maxOtherDocumentcount ? (
                <>
                  <NeoTextBox
                    label="Document Name"
                    id="phone No"
                    defaultValue={nameothers}
                    value={nameothers}
                    onChange={(e: any) => setNameothers(e.target.value)}
                    placeholder="Please enter other document name"
                    size="md"
                  />
                  <div className="max-h-40 overflow-y-auto pr-2">
                    {fileInputsOthers.map((_, index) => (
                      <div
                        key={index}
                        className="mt-1 flex items-center space-x-4"
                      >
                        <input
                          type="file"
                          accept="image/*,application/pdf"
                          className="block w-full text-sm text-gray-500 file:mr-4 file:rounded-md file:border-0
              file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700
              hover:file:bg-blue-100"
                          onChange={e =>
                            handleOtherFileChange(
                              index,
                              e.target.files?.[0] ?? null
                            )
                          }
                        />
                        <button
                          onClick={() => {
                            const newInputs = [...fileInputsOthers];
                            const newFiles = [...filesOthers];
                            newInputs.splice(index, 1);
                            newFiles.splice(index, 1);
                            setFileInputsOthers(newInputs);
                            setFilesOthers(newFiles);
                          }}
                          className="text-sm text-red-500 hover:text-red-700"
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="flex items-center justify-between rounded-lg border bg-gray-50 p-4">
                  <p className="text-sm font-medium text-red-500">
                    * A maximum of 3 files can be uploaded. To upload more,
                    please delete files from the{" "}
                    <button
                      type="button"
                      className="text-blue-600 underline hover:text-blue-800"
                      onClick={onClose} // Replace with your actual handler
                    >
                      View Page
                    </button>
                    .
                  </p>
                </div>
              )}
            </div>
            {fileNameValiadationOthDoc && (
              <p className="text-sm font-medium text-red-500">
                {fileNameValiadationOthDoc}
              </p>
            )}
          </div>
          <div className="flex flex-col items-center justify-end">
            {/* <button
                type="button"
                onClick={addFileInput}
                className="mt-2 text-sm text-blue-600 underline"
              >
                + Add Another
              </button> */}
            {((maxOtherDocumentcount > 0 &&
              allowedCount >= maxOtherDocumentcount) ||
              (maxDocumentcount > 0 && allowedCount >= maxDocumentcount)) && (
              <NeoButton
                className="mx-2 mt-2"
                type="submit"
                size="sm"
                // disabled={isSubmitting}
                isLoading={loading}
                spinner={
                  <AiOutlineLoading
                    size="xs"
                    className="animate-spin h-6 w-6"
                  />
                }
                color="black"
                onClick={() => {
                  onSubmit();
                }}
              >
                Upload Files
              </NeoButton>
            )}
            {errorMessage ? <NeoError message={errorMessage}></NeoError> : null}

            {succssMessage ? (
              <NeoSuccess message={succssMessage}></NeoSuccess>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};
